import React from 'react'

import { IntegerField, IIntegerProps } from 'src/pages/Policies/Editor/fields'

interface IPositiveIntegerField extends Omit<IIntegerProps, 'minimum'> {
  strictly?: boolean | undefined
}

/**
 * @param {boolean} [strictly] - default the minimum value to either 0 (false) or 1 (true)
 */
export default function (props: IPositiveIntegerField) {
  const { strictly, ...integerProps } = props
  return <IntegerField {...integerProps} minimum={strictly ? 1 : 0} />
}
